import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hi, I would like to report an accident\n',
    },
    content: {
      exclude: {
        items: [
          'Accidents as a result of playing a sport professionally.',
          'Accidents that occur following the use of recreational drugs or medicines, whether obtained fraudulently or not prescribed by a competent medical authority.',
        ],
        title: 'This coverage does not include',
      },
      include: {
        items: [
          '€100 per day if you are admitted to hospital following an accident, from the first night up to 50 days.',
          '€5,000 to your beneficiaries in the event of your death following an accident.',
          'Protection extended to your employees.',
        ],
        title: 'This coverage includes',
      },
    },
    similarOffersTitle: 'Other insurances related to your coverage',
    title: 'Accident coverage',
  },
  fr: {
    claimButton: {
      intercomMessage: 'Bonjour, je souhaiterais déclarer un accident\n',
    },
    content: {
      exclude: {
        items: [
          'Les accidents survenus suite à une pratique sportive professionnelle.',
          "Les accidents survenus suite à l'usage de stupéfiants ou produits médicamenteux obtenus frauduleusement ou non prescrits par une autorité médicale compétente.",
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          "100\xa0€ par jour en cas d'hospitalisation suite à un accident, dès la première nuit et jusqu'à 50 jours.",
          '5\xa0000\xa0€ à vos ayants droit en cas de décès suite à un accident.',
          'La protection étendue à vos employé·es.',
        ],
        title: 'Cette garantie inclut',
      },
    },
    similarOffersTitle: 'Autres assurances liées à votre couverture',
    title: 'Garantie accident',
  },
} as const);

export default locales;
